export interface IEsRequestBuilder {
	buildRequest(props: Dict<any>): JEsRequest
}

export class EsRequestBuilderFake implements IEsRequestBuilder {
	buildRequest(props: Dict<any>): JEsRequest {
		return {
			"query": {
				"bool": {
					"must": {
						"query_string": {
							"query": props.text || "*"
						}
					},
					"filter": {
						"term": {
							"scgroup": "res"
						}
					}
				}
			}
		}
	}
}


/**
 * Typage simplifié d'une requête ES
 * issu de https://github.com/elastic/elasticsearch-js/blob/main/src/api/types.ts
 */
export interface JEsRequest {
	//todo
}

/**
 * Typage simplifié d'une réponse ES
 * issu de https://github.com/elastic/elasticsearch-js/blob/main/src/api/types.ts
 */
export interface JEsResponse {
	took: number
	timed_out: boolean
	hits: {
		total?: number | { relation: 'eq' | 'gte', value: number }
		hits: JEsHit[]
		max_score?: number | null
	}
	aggregations?: any
	max_score?: number
}

export interface JEsHit {
	_index: string
	_id: string
	_score?: number | null
	fields?: Dict<any>
	highlight?: Dict<string[]>
	matched_queries?: string[]
	//inner_hits?: Dict<SearchInnerHitsResult>
	//_nested?: SearchNestedIdentity
	_source?: Dict<any>
	sort?: (number | string | null)[]
}